// extracted by mini-css-extract-plugin
export default {"TableHeader":"ServiceProvidersTable_TableHeader__xHumj","Icon":"ServiceProvidersTable_Icon__M-GQ+"};